import { combineReducers } from 'redux';

import { parseIntent } from 'Lib/intent/utils';
import type { Reducer } from 'Lib/reduxType';

import { getCommonResetAction } from 'Store/commonActions';

import { CLEAR_INTENT, HANDLE_INTENT } from './constants';
import initialState from './initialState';
import type { IntentState } from './types';

const parsedResultReducer: Reducer<IntentState['parsedResult']> = (
  state = initialState.parsedResult,
  action
) => {
  switch (action.type) {
    case HANDLE_INTENT: {
      const { intent } = action.payload;
      if (intent) {
        const parsedObject = parseIntent(intent);
        return parsedObject;
      }
      break;
    }
    case CLEAR_INTENT:
    case getCommonResetAction(action.type):
      return initialState.parsedResult;

    default:
      return state;
  }
};

export const reducer = combineReducers({
  parsedResult: parsedResultReducer,
});
